import styled, { css } from 'styled-components';
import { Dialog } from '@material-ui/core';

export const ModalStyled = styled(Dialog)`
	div[class*='MuiPaper-root'] {
		width: 100%;
		max-width: 800px;
	}

	${props =>
		props.size === 'xs' &&
		css`
			div[class*='MuiPaper-root'] {
				max-width: 400px;
			}
		`};

	${props =>
		props.size === 'sm' &&
		css`
			div[class*='MuiPaper-root'] {
				max-width: 600px;
			}
		`};

	${props =>
		props.size === 'lg' &&
		css`
			div[class*='MuiPaper-root'] {
				max-width: 1000px;
			}
		`};
`;

export const Inner = styled.div``;

export const Button = styled.button`
	background: none;
	position: absolute;
	top: 17px;
	right: 10px;
	border: none;
	outline: none;
	color: ${(props) => props.theme.colors.modalButtonClose};
	cursor: pointer;
	i {
		font-size: 22px;
	}
`;
